<template>
  <div class="flux-regalo">
    <div class="flux-regalo__title">{{ $t("guest.purchaseFlow.leaveYourDetails") }}</div>

    <div class="flux-regalo__msg">
      {{ $t("guest.purchaseFlow.leaveYourDetailsDescription", { name: myList.ownerName }) }}
    </div>

    <div class="flux-regalo__field">
      <label class="flux-regalo__label">
        {{ $t("guest.purchaseFlow.hideIdentity") }}
        <span
          class="tooltip-icon"
          v-tooltip="{
            content: $t('guest.purchaseFlow.hideIdentityTooltip', { name: myList.ownerName }),
            placement: 'top',
            triggers: ['hover', 'click']
          }"
        >
          <img src="../../../assets/img/ico/ico-question.svg" alt="Tooltip" />
        </span>
      </label>
      <!-- <div class="flux-regalo__msg">
        ¿Quieres que ocultemos tu identidad?
      </div>
      <div class="flux-regalo__msg flux-regalo__msg--small">
        <img src="../../../assets/img/ico/ico-question.svg" alt="" />
        Recogeremos tus datos pero no se los comunicaremos a {{ myList.ownerName }} cuando le avisemos.
      </div> -->
      <div class="bb-survey__items">
        <div class="bb-survey__item">
          <div class="bb-form-checkbox">
            <input type="radio" name="checkbox" id="yes" value="yes" v-model="anonymous"/>
            <label for="emptyList" class="bb-form-checkbox__label">
              {{ $t("generic.yes") }}
            </label>
          </div>
        </div>
        <div class="bb-survey__item">
          <div class="bb-form-checkbox">
            <input type="radio" name="checkbox" id="no" value="no" v-model="anonymous" />
            <label for="listWithIdeas" class="bb-form-checkbox__label">
              {{ $t("generic.no") }}
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="flux-regalo__field flux-regalo__field--selector" style="margin-bottom: 2.5rem;" />

    <div class="flux-regalo__field">
      <InputText
        v-model="form.name"
        class="input"
        :label="$t('form.name')"
        :placeholder="$t('form.namePlaceholder')"
        :errorLabel = errorName
        required></InputText>
    </div>

    <div class="flux-regalo__field">
      <InputText
        v-model="form.email"
        class="input"
        type="email"
        :label="$t('form.email')"
        :placeholder="$t('form.emailPlaceholder')"
        :errorLabel = errorEmail
        required></InputText>
    </div>

    <!-- Quiero recibir emails de HelloBB. -->
     <div class="flux-regalo__field">
      <label class="w-checkbox">
        <input
          type="checkbox"
          v-model="form.tos"
          class="w-checkbox-input"
        />
        <span class="flux-regalo__tos">{{ $t("guest.purchaseFlow.acceptTos") }}</span>
      </label>
    </div>

    <div class="flux-regalo__field flux-regalo__field--selector" style="margin-bottom: 2.5rem;" />

    <loading-button v-if="loading" />
    <div v-else class="flux-regalo__actions">
      <button class="button button--primary" @click.prevent="nextStep()">
        {{ $t("guest.setAsPurchasedButton") }}
      </button>
    </div>
  </div>
</template>
<script>
//import CompradoYa from "./mixins/CompradoYa";
import InputText from "../../../components/forms/InputText.vue";
import LoadingButton from "../../../components/LoadingButton";
import { mapGetters } from "vuex";
import { VTooltip } from "floating-vue";

export default {
  name: "FluxRegaloStep3",
  //mixins: [CompradoYa],
  components: {
    InputText,
    LoadingButton,
  },
  directives: {
    tooltip: VTooltip,
  },
  props: {
    retailer: {
      required: true,
    },
    product: {
      required: true,
    },
    list: {
      required: true,
    },
  },
  data() {
    return {
      anonymous: "no",
      form: {
        name: "",
        email: "",
        tos: false,
      },
      loading: false,
      errorEmail: "",
      errorName: "",
    };
  },
  computed: {
    ...mapGetters({
      myList: "myList",
    }),
  },
  methods: {
    async nextStep() {
      this.errorEmail = "";
      this.errorName = "";
      //name and email are required
      if (!this.form.name) {
        this.errorName = this.$t("form.nameRequired");
      }
      if (!this.form.email) {
        this.errorEmail = this.$t("form.emailRequired");
      }
      else if (!this.$utils.validateEmail(this.form.email)) {
        this.errorEmail = this.$t("form.emailInvalid");
      }
      if (this.errorName || this.errorEmail) {
        return;
      }

      this.loading = true
      var body = {
        anonymous: this.anonymous === "yes",
        isFreeProduct: this.product.isFree,
        buyerName: this.form.name,
        buyerEmail: this.form.email,
        tos: this.form.tos,
      };
      await this.$store.dispatch("sendPurchaseInfo", {
        list: this.list,
        productId: this.product.isFree ? this.product.id : this.product.listProductId,
        body,
      });
      this.loading = false
      this.$emit('next')
    }, 
  },
};
</script>
